import axios from 'axios';

import { tecDocUrl, PROVIDER_ID, basicAuth } from 'utils/constantsHelper';
import { langCode } from 'utils/currentLanguage';

const headers = {
  searchExact: true,
  sortType: '1',
  provider: PROVIDER_ID,
};

export const getCarsByRef = (articlesNumber, numberType, articleCountry) => {
  return axios.post(
    tecDocUrl,
    {
      getArticleDirectSearchAllNumbersWithState: {
        articleNumber: articlesNumber,
        numberType: numberType,
        lang: langCode,
        articleCountry: articleCountry,
        ...headers,
      },
    },
    { headers: basicAuth }
  );
};



// WEBPACK FOOTER //
// ./src/utils/getCarsByRef.js